module.exports = __webpack_public_path__ + "img/product-feature.e2aae537.png";